import { render } from "./workers.vue?vue&type=template&id=21c22960&scoped=true&ts=true"
import script from "./workers.vue?vue&type=script&lang=ts"
export * from "./workers.vue?vue&type=script&lang=ts"

import "./workers.vue?vue&type=style&index=0&id=21c22960&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c22960"]])

export default __exports__